var _defs, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFestivaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 123.3 35.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: url(#linear-gradient2);\r\n      }\r\n\r\n      .st1 {\r\n        fill: url(#linear-gradient10);\r\n      }\r\n\r\n      .st2 {\r\n        fill: url(#linear-gradient1);\r\n      }\r\n\r\n      .st3 {\r\n        fill: url(#linear-gradient9);\r\n      }\r\n\r\n      .st4 {\r\n        fill: url(#linear-gradient8);\r\n      }\r\n\r\n      .st5 {\r\n        fill: url(#linear-gradient11);\r\n      }\r\n\r\n      .st6 {\r\n        fill: #6b7262;\r\n      }\r\n\r\n      .st7 {\r\n        fill: url(#linear-gradient12);\r\n      }\r\n\r\n      .st8 {\r\n        fill: url(#linear-gradient7);\r\n      }\r\n\r\n      .st9 {\r\n        fill: url(#linear-gradient4);\r\n      }\r\n\r\n      .st10 {\r\n        fill: #586448;\r\n      }\r\n\r\n      .st11 {\r\n        fill: url(#linear-gradient14);\r\n      }\r\n\r\n      .st12 {\r\n        fill: url(#linear-gradient5);\r\n      }\r\n\r\n      .st13 {\r\n        fill: url(#linear-gradient3);\r\n      }\r\n\r\n      .st14 {\r\n        fill: url(#linear-gradient6);\r\n      }\r\n\r\n      .st15 {\r\n        fill: url(#linear-gradient13);\r\n      }\r\n\r\n      .st16 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.5,
    y1: 14.1,
    x2: 2.5,
    y2: 8.7,
    gradientTransform: "translate(0 21.2) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a8172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515847"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    y1: 8.5,
    y2: 3.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    y1: 2.9,
    y2: -2.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    y1: -2.7,
    y2: -8.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 7.3,
    x2: 7.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 7.3,
    y1: 8.5,
    x2: 7.3,
    y2: 3.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 7.3,
    y1: 2.9,
    x2: 7.3,
    y2: -2.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 7.3,
    y1: -2.7,
    x2: 7.3,
    y2: -8.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: 12.1,
    x2: 12.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: 12.1,
    y1: 8.5,
    x2: 12.1,
    y2: 3.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: 12.1,
    y1: 2.9,
    x2: 12.1,
    y2: -2.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: 12.1,
    y1: -2.7,
    x2: 12.1,
    y2: -8.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient12",
    x1: 16.8,
    x2: 16.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient13",
    x1: 16.8,
    y1: 8.5,
    x2: 16.8,
    y2: 3.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient14",
    x1: 16.8,
    y1: -2.7,
    x2: 16.8,
    y2: -8.1,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M48,16.6v-.3c.7-.2.8-.8.8-2.3V5.2c0-1.4-.1-2-.8-2.3v-.3h9.7v2.2c.1,0-.1,0-.1,0-.7-1.4-1.6-1.9-3.6-1.9h-3v5.8h1.6c2.4,0,3.1-.5,3.5-1.5h.3v3.4h-.3c-.3-1-1-1.5-3.5-1.5h-1.6v4.9c0,1.4.1,2,.8,2.3v.3h-3.7ZM59.2,16.6v-.3c.7-.2.8-.8.8-2.3V5.2c0-1.4-.1-2-.8-2.3v-.3h9.6l.2,2.8h-.3c-.8-1.9-2.1-2.5-4.3-2.5h-2.3v6h1.9c2.4,0,3.1-.5,3.5-1.5h.3v3.4h-.3c-.3-1-1-1.5-3.5-1.5h-1.9v6c0,.6.4,1,1,1h1.9c2,0,3.4-.6,4.2-2.6h.3s-.1,3-.1,3h-10.1ZM75.9,16.8c-2.1,0-3.9-.7-4.9-1.4v-3c0,0,.2,0,.2,0,.8,2.3,2.6,4,5.3,4s2.7-.9,2.7-2.5-2.6-2.9-4.2-3.5c-2.1-.9-3.8-1.5-3.8-3.9s2-4,5.1-4,2.8.3,3.8.8v2.6c0,0-.1,0-.1,0-.8-2.1-2.5-3.2-4.5-3.2s-2.9.9-2.9,2.5,2,2.5,3.6,3.1c2,.8,4.5,1.7,4.5,4.1s-2.5,4.3-4.8,4.3ZM85,16.6v-.3c.7-.2.8-.8.8-2.3V3h-.6c-1.8,0-2.7.5-3.4,2.1h-.2s.1-2.5.1-2.5h10.4v2.4c.1,0-.1,0-.1,0-.7-1.6-1.6-2.1-3.4-2.1h-.6v11.1c0,1.4.1,2,.8,2.3v.3h-3.7ZM93.4,16.6v-.3c.7-.2.8-.8.8-2.3V5.2c0-1.4-.1-2-.8-2.3v-.3h3.7v.3c-.7.2-.8.8-.8,2.3v8.9c0,1.4.1,2,.8,2.3v.3h-3.7ZM99.5,5c-.5-1.3-1-1.9-1.5-2.1v-.3h3.7v.3c-.7.2-.4.7.1,2.1l3.7,9.3,3.6-9.3c.5-1.3.4-1.9-.3-2.1v-.3h2.3v.3c-.6.2-1.1.7-1.6,2.1l-4.5,11.6h-.8l-4.7-11.6ZM108.4,16.6v-.3c.6-.2,1.1-.7,1.7-2.1l3.7-9.3c.2-.4.1-.7,0-1.1l-.3-.6,2-.9,5,11.8c.6,1.3,1.1,1.8,1.5,2.1v.3h-3.6v-.3c.7-.2.4-.7-.2-2.1l-1.2-2.9h-5.3l-1.2,2.9c-.5,1.3-.4,1.9.3,2.1v.3h-2.3ZM111.7,11.1h5.1l-2.6-6.2-2.5,6.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M58.6,30.6v-.2c.4-.1.4-.5.4-1.2v-4.9c0-.8,0-1.1-.4-1.2v-.2h2.7c1.8,0,2.5.6,2.5,1.5s-.5,1.4-1.9,1.7c1.8,0,2.7.9,2.8,2,0,1.3-1,2.6-3.7,2.6h-2.4ZM60.2,29.5c0,.8,0,1,.6,1h.3c1.6,0,2.3-.8,2.3-2s-.7-2.3-2.4-2.3h-.8v3.3ZM60.2,26h1c.8,0,1.3-.6,1.3-1.4s-.7-1.5-1.8-1.5h-.5v2.9ZM65.1,32.8c-.5,0-.8-.1-.8-.4s.3-.7.8-.7.9,0,1.5.2c.3-.3.5-.7.8-1.2l-1.8-4.3c-.3-.7-.6-1-.9-1.1v-.2h1.9v.2c-.4.1-.2.4.1,1.1l1.3,2.9,1.2-2.8c.3-.7.3-1-.1-1.1v-.2h1.3v.2c-.3.1-.6.4-1,1.1l-1.7,3.9c-.8,1.9-1.6,2.4-2.6,2.5ZM74.6,30.6v-.2c.4-.1.4-.5.4-1.2v-6.1h-.3c-1,0-1.5.3-1.9,1.2h-.1s0-1.4,0-1.4h5.7v1.3c0,0,0,0,0,0-.4-.9-.9-1.2-1.9-1.2h-.3v6.1c0,.8,0,1.1.4,1.2v.2h-2.1ZM80.4,30.7c-1.2,0-2.6-.9-2.6-2.7s1.5-3,2.9-3,2.3,1,2.3,2h-4.2c0,.1,0,.2,0,.4,0,1.4.9,2.5,2.3,2.5s1.4-.4,1.9-.9h0c-.5.9-1.4,1.8-2.7,1.8ZM78.8,26.9h3c-.1-.9-.7-1.6-1.5-1.6-.9,0-1.4.8-1.5,1.6ZM86.3,30.7c-1.4,0-2.6-.9-2.6-2.7s1.4-3,3-3,2,.3,2,.6-.4.7-.7.7-.8-.3-1.7-1.2c-1,.1-1.6,1.1-1.6,2.1s.9,2.5,2.3,2.5,1.4-.4,1.9-.9h0c-.5.9-1.4,1.8-2.7,1.8ZM92.3,30.7c-1.4,0-2.9-.8-2.9-2.7s1.4-3,2.9-3,2.9.8,2.9,2.7-1.6,2.9-2.9,2.9ZM90.5,27.2c0,1.3.8,3.3,2.2,3.3s1.4-.9,1.4-1.9c0-1.4-1-3.5-2.4-3.4-1,0-1.3,1-1.3,1.9ZM97.6,33.7c-.7,0-1.7-.3-1.7-1.3s.5-1.2,1.4-1.7c-.5-.1-.7-.4-.7-.8s.3-.7.9-1.1c-.6-.3-1-.8-1-1.6s1-2.1,2.2-2.1.5,0,.8,0c.2-.2.4-.4.6-.6.4-.3.7-.4,1.2-.4s.6,0,.6.3-.2.7-.7.7-.6,0-1.2-.3c-.1,0-.2.2-.3.4.7.2,1.3.8,1.3,1.7s-1.3,2.1-2.2,2.1-.7,0-1.1-.2c-.2.1-.3.2-.3.4s.2.4,1.2.5h1.5c1.1.2,1.7.4,1.7,1.1,0,1.2-1.9,2.8-3.9,2.8ZM96.8,31.8c0,.9.8,1.2,1.6,1.2,1.5,0,2.6-.8,2.6-1.5s-.2-.6-1.1-.6h-1.8c-.3,0-.5-.1-.7-.2-.5.4-.6.7-.6,1.1ZM97.4,26.6c0,.9.4,2.3,1.5,2.3s1-.6,1-1.3c0-1-.6-2.4-1.6-2.3-.7,0-.9.7-.9,1.3ZM101.9,30.6v-.2c.4-.1.4-.5.4-1.2v-2.5c0-.6-.2-.8-.4-.9v-.2l1.5-.6h.1v4.2c0,.8,0,1.1.4,1.2v.2h-2ZM102.1,23.9c0-.4.3-.8.7-.8s.7.3.7.8-.3.7-.7.7-.7-.3-.7-.7ZM106.6,30.7c-.8,0-1.6-.2-2-.5v-1.4c-.1,0,0,0,0,0,.5,1.1,1.3,1.8,2.2,1.8.7,0,1.1-.4,1.1-.9s-.6-1-1.5-1.3c-1.2-.4-1.9-.7-1.9-1.7s.6-1.6,2.1-1.6,1.3.1,1.7.3v1.2c0,0,0,0,0,0-.4-.8-1.1-1.4-1.9-1.4s-1.1.4-1.1.8.5.9,1.5,1.2c.9.3,1.8.6,1.8,1.7s-.5,1.8-2.1,1.8Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M33,18.3l4.2,2.7-4.2,2.7v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M.5,7l4.2,2.7L.5,12.4v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M.5,12.7l4.2,2.7L.5,18v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M.5,18.3l4.2,2.7L.5,23.6v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M.5,23.9l4.2,2.7L.5,29.2v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M5.2,7l4.2,2.7-4.2,2.7v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M5.2,12.7l4.2,2.7-4.2,2.7v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M5.2,18.3l4.2,2.7-4.2,2.7v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M5.2,23.9l4.2,2.7-4.2,2.7v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M10,7l4.2,2.7-4.2,2.7v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10,12.7l4.2,2.7-4.2,2.7v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,18.3l4.2,2.7-4.2,2.7v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M10,23.9l4.2,2.7-4.2,2.7v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M14.7,7l4.2,2.7-4.2,2.7v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M14.7,12.7l4.2,2.7-4.2,2.7v-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M14.7,23.9l4.2,2.7-4.2,2.7v-5.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFestivaLogo);
export default __webpack_public_path__ + "static/media/festiva_logo.266b6add24a835bba1997bdccf99bf25.svg";
export { ForwardRef as ReactComponent };